// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.VizEngineFactories.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

import Factories from './Izenda.Factories';
import VizEngine from 'share/components/charting/Izenda.VizEngine';
const vizFactories = new Factories('Visualization Engine', true, (name, chartType) => `${name}_${chartType}`);

export default {
  /**
   * Register a visualization engine with a name
   * @param {string} name The name of visualization engine
   * @param {any} vizEngineClazz The class of visualization engine
   */
  registerVisualizationEngine(name, vizEngineClazz) {
    ensure(vizEngineClazz.prototype instanceof VizEngine, 'Visualization engine class must inherit from VizEngine');

    vizFactories.containKey(name) && vizFactories.unregister(name);

    vizFactories.register(name, (key, chartType) => new vizEngineClazz());
  },

  /**
   * Get visualization engine by name
   * @param {string} name The name of visualization engine
   * @param {string} chartType The chart type
   */
  getVisualizationEngine(name, chartType) {
    // Pass additional chart type for resolving cache key of factories
    return vizFactories.create(name, chartType);
  },

  /**
   * Reset the factories data
   */
  reset() {
    vizFactories.reset();
  }
};



// WEBPACK FOOTER //
// ./ui/share/factories/Izenda.VizEngineFactories.js